import { useTranslation } from "react-i18next";
import NavbarComponent from "../components/NavbarComponent";

import "../styles/projects/project-main.css";
import { Alert, Container } from "react-bootstrap";
import { TechnologyBadgeComponent } from "../components/TechnologyBadgeComponent";
import useLocalizedProjects from "../hooks/useLocalizedProjects";
import { useLocation } from "react-router-dom";
import ProjectScreenshotsComponent from "../components/ProjectScreenshotsComponent";

const PetDex = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const projectsData = useLocalizedProjects();
  const fetchProjectData = projectsData.data.filter(
    (item) => item.projectLink === pathname
  );
  const projectData = fetchProjectData[0];

  return (
    <>
      <NavbarComponent />

      <div className="project-body">
        <Container>

          <h1 className="project-page-title">{projectData.title}</h1>

          <TechnologyBadgeComponent
            technologiesList={projectData.technologies}
          />

          <Alert variant="success" className="project-page-alert mb-5">
            {t('petDex.alert')}
          </Alert>

          <ProjectScreenshotsComponent imagesList={projectData.sampleImages} imageSize={12} />
        </Container>
      </div>
    </>
  );
};
export default PetDex;
